





















































import Vue from 'vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import {DELETE_USER_MESSAGES, REMOVE_USER_MESSAGES} from '@/store/action-types'
import { TranslateResult } from 'vue-i18n'
import { UserMessage } from '@/model/messaging/UserMessage'

interface MessagePosition {
  top: string
  left: string
  width: string
  height: string
}

interface ComponentData {
  positions: any
  loading: boolean
  saveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  headers: any
  tableSize: Object
}

export default Vue.extend({
  name: 'EmployeeMessagesDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    messageList: Array as () => UserMessage[]
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      loading: false,
      saveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      headers: [
        { text: this.$t('messaging.time').toString(), value: 'time', align: 'start', groupable: false, width: 80 },
        { text: this.$t('messaging.origin').toString(), value: 'origin', align: 'start', groupable: false, width: 120 },
        { text: this.$t('messaging.message').toString(), value: 'message', align: 'start', groupable: false, maxWidth: 250 }
      ],
      tableSize: {}
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 186)
      const left : number = (window.innerWidth -624)
      return {top: `${top}px`, left: `${left}px`}
    },

    getWindowStyle (): Object {
      const top : number = (window.innerHeight - 186)
      return {top: `${top}px`, left: `0px`, position: 'fixed', width: '100%', padding: '4px'}
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  methods: {
    async onDeleteMessages () {
      this.setMessagePosition()

      const payload = this.messageList.map((i: any) => {
        return i.id
      })

      try {
        this.loading = true
        await this.$store.dispatch(DELETE_USER_MESSAGES, payload)
        this.$store.dispatch(REMOVE_USER_MESSAGES)
        this.loading = false
        this.$emit('close')
      } catch {
        this.loading = false
      }
    },

    onCopyMessages () {
      let text: string = ''
      this.messageList.forEach((item: UserMessage) => {
        text = text + `${item.time}    ${item.origin}    ${item.message} \n`
      })
      navigator.clipboard.writeText(text)
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > 0 && (container.offsetTop - this.positions.movementY + container.clientHeight + 0) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < 0) {
        container.style.top = 0 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 0 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 0)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }

      this.setMessagePosition()
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },

    setMessagePosition (): void {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      if(container) {
        const messagePosition: MessagePosition = {
          top: container.style.top ? container.style.top.toString() : (window.innerHeight - 186).toString(),
          left: container.style.left ? container.style.left.toString() : (window.innerWidth - 624).toString(),
          width: container.clientWidth ? container.clientWidth.toString() : '600',
          height: container.clientHeight ? container.clientHeight.toString() : '180'
        }
        localStorage.setItem("messagePosition", JSON.stringify(messagePosition))
      }
    }
  },

  mounted (): void {
    if(localStorage.getItem("messagePosition")) {
      const startPosition: MessagePosition = JSON.parse(localStorage.getItem("messagePosition")!)
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      if(container) {
        container.style.top = startPosition.top
        container.style.left = startPosition.left
        const tableHeight: number = parseInt(startPosition.height) - 64
        this.tableSize = { height: `${tableHeight}px`, width: `${startPosition.width}px` }
      }
    }
  }
})
